var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3703",
    transform: "translate(-167 -1884)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ebebeb",
    "data-name": "Ellipse 688",
    transform: "translate(167 1884)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3603",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3601"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m217.104 1905.42-4.6-1.744-.474-9.676c2.032 0 3.046.53 3.046 2.561Z",
    "data-name": "Path 4422"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m187.002 1905.42 4.6-1.744.474-9.676c-2.032 0-3.046.53-3.046 2.561Z",
    "data-name": "Path 4423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m187 1932.619 4.593 1.744.474 9.672c-2.031 0-3.045-.529-3.045-2.56Z",
    "data-name": "Path 4424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "m217.09 1932.619-4.593 1.744-.474 9.672c2.031 0 3.044-.529 3.044-2.56Z",
    "data-name": "Path 4425"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3,
    "data-name": "Ellipse 687",
    transform: "translate(181 1898.273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.586,
    cy: 20.586,
    r: 20.586,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.586,
    cy: 20.586,
    r: 19.086
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M222.413 1914h2.227a.16.16 0 0 1 .162.162v9.084a.163.163 0 0 1-.163.163h-2.226a.163.163 0 0 1-.163-.163v-9.083a.163.163 0 0 1 .163-.163",
    "data-name": "Rectangle 4703"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0e2240",
    "data-name": "Group 3604"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.413 1916.469a.554.554 0 0 0-.479.6v3.607a.492.492 0 1 0 .958 0v-3.6a.55.55 0 0 0-.479-.6Zm0 0",
    "data-name": "Path 4426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.482 1916.469a.554.554 0 0 0-.482.6v3.607a.493.493 0 1 0 .961 0v-3.6a.554.554 0 0 0-.479-.6Zm0 0",
    "data-name": "Path 4427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.392 1911a1.717 1.717 0 0 0-1.6 1.813v12.129a1.614 1.614 0 1 0 3.2 0v-4.6h11.65v4.6a1.614 1.614 0 1 0 3.2 0v-12.132a1.614 1.614 0 1 0-3.2 0v4.6h-11.65v-4.6a1.716 1.716 0 0 0-1.6-1.81m0 0",
    "data-name": "Path 4428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.967 1913.42h-.156a1.2 1.2 0 0 0-1.206 1.206v8.5a1.21 1.21 0 0 0 1.206 1.209h.156a1.21 1.21 0 0 0 1.209-1.206v-8.5a1.21 1.21 0 0 0-1.209-1.208Zm0 0",
    "data-name": "Path 4429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.907 1913.42h-.156a1.207 1.207 0 0 0-1.209 1.206v8.5a1.21 1.21 0 0 0 1.209 1.209h.156a1.205 1.205 0 0 0 1.206-1.206v-8.5a1.2 1.2 0 0 0-1.206-1.208Zm0 0",
    "data-name": "Path 4430"
  })))));
};
export { SvgWeight as ReactComponent };
export default "/_next/static/images/weight.svg";